export const isNullable = (value: unknown): value is null | undefined => value === null || value === undefined;

export const isNonNullable = <T>(value: T): value is Exclude<T, null | undefined> => !isNullable(value);

export const isEmpty = (value: string | unknown[] | object): boolean => {
    if (Array.isArray(value)) {
        return value.length === 0;
    }

    if (typeof value === 'object') {
        return Object.keys(value).length === 0;
    }

    return value === '';
};

export const isNotEmpty = (value: string | unknown[] | null | undefined): boolean => {
    return isNonNullable(value) && !isEmpty(value);
};
